import React from 'react';

import Icon from '../Icon';

const AiAssistantCloseIcon = (props) => {
    return (
        <Icon width='19' height='19' viewBox='0 0 19 19' fill='none' {...props}>
            <rect
                x='16.9998'
                y='0.414062'
                width='2'
                height='24'
                rx='1'
                transform='rotate(45 16.9998 0.414062)'
                fill='white'
            />
            <rect y='1.41431' width='2' height='24' rx='1' transform='rotate(-45 0 1.41431)' fill='white' />
        </Icon>
    );
};

export default AiAssistantCloseIcon;
